import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PaymentCheckoutWizardModule } from '@app/account/shared/payment-checkout-wizard/payment-checkout-wizard.module';
import { ContentCardModule } from '@app/library/content-card/content-card.module';
import { CollectionReviewFormComponent } from '@app/library/panes/collection-review-form/collection-review-form.component';
import { LessonComponent } from '@app/library/panes/grid-card-universal/components/lesson/lesson.component';
import { AlertModule } from '@core/components/alert/alert.module';
import { AuthorInfoComponent } from '@core/components/author-info/author-info.component';
import { BookmarkComponent } from '@core/components/bookmark/bookmark.component';
import { MobileModalModule } from '@core/components/mobile-modal/mobile-modal.module';
import { ModalModule } from '@core/components/modal/modal.module';
import { SubscribeComponent } from '@core/components/subscribe/subscribe.component';
import { CoreModule } from '@core/core.module';
import { TranslateModule } from '@ngx-translate/core';
import { ComplaintFormModule } from '@shared/complaint-form/complaint-form.module';
import { IconComponent } from '@shared/icon/icon.component';
import { StatusBadgeComponent } from '@shared/layouts/status-badge/status-badge.component';
import { RatingComponent } from '@shared/rating/rating.component';
import { SkeletonComponent } from '@shared/skeleton/skeleton.component';
import { PaymentFormUniversalModule } from 'lingo2-forms';
import { DateFnsModule } from 'lingo2-ngx-date-fns';
import { ClipboardModule } from 'ngx-clipboard';

import { OnUiButtonModule, OnUiCardMenuModule, OnUiCoverModule, OnUiPopoverModule, OnUiTabsModule } from 'onclass-ui';
import { CollectionLicensePricesModule } from '../collection-license-prices/collection-license-prices.module';
import { CollectionMetaModule } from '../collection-meta/collection-meta.module';
import { ContentCardMiniReadonlyModule } from '../content-card-mini-readonly/content-card-mini-readonly.module';
import { PaidContentInformerModule } from '../paid-content-informer/paid-content-informer.module';
import { CollectionCardComponent } from './collection-card.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    ClipboardModule,
    OnUiPopoverModule,
    CoreModule,
    ModalModule,
    MobileModalModule,
    ContentCardMiniReadonlyModule,
    PaidContentInformerModule,
    CollectionMetaModule,
    CollectionLicensePricesModule,
    PaymentFormUniversalModule,
    IconComponent,
    OnUiCardMenuModule,
    OnUiCoverModule,
    OnUiButtonModule,
    ComplaintFormModule,
    DateFnsModule,
    StatusBadgeComponent,
    OnUiTabsModule,
    AlertModule,
    SubscribeComponent,
    BookmarkComponent,
    PaymentCheckoutWizardModule,
    CollectionReviewFormComponent,
    LessonComponent,
    RatingComponent,
    LessonComponent,
    SkeletonComponent,
    ContentCardModule,
    AuthorInfoComponent,
  ],
  declarations: [CollectionCardComponent],
  exports: [CollectionCardComponent],
})
export class CollectionCardModule {}
